/* tslint:disable */
/* eslint-disable */
/**
 * PRMGApp
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { CarBodyTypeFromJSON, CarBodyTypeToJSON, CarPaintProtectionTypeFromJSON, CarPaintProtectionTypeToJSON, DriveTypeFromJSON, DriveTypeToJSON, FuelTypeFromJSON, FuelTypeToJSON, GearTypeFromJSON, GearTypeToJSON, PaintEffectTypeFromJSON, PaintEffectTypeToJSON, } from './';
export function CarServiceDtoFromJSON(json) {
    return CarServiceDtoFromJSONTyped(json, false);
}
export function CarServiceDtoFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'bodyType': !exists(json, 'bodyType') ? undefined : CarBodyTypeFromJSON(json['bodyType']),
        'fuel': !exists(json, 'fuel') ? undefined : FuelTypeFromJSON(json['fuel']),
        'engineOil': !exists(json, 'engineOil') ? undefined : json['engineOil'],
        'drive': !exists(json, 'drive') ? undefined : DriveTypeFromJSON(json['drive']),
        'gear': !exists(json, 'gear') ? undefined : GearTypeFromJSON(json['gear']),
        'bodyColorId': !exists(json, 'bodyColorId') ? undefined : json['bodyColorId'],
        'bodyColorMakeCode': !exists(json, 'bodyColorMakeCode') ? undefined : json['bodyColorMakeCode'],
        'paintEffect': !exists(json, 'paintEffect') ? undefined : PaintEffectTypeFromJSON(json['paintEffect']),
        'paintProtection': !exists(json, 'paintProtection') ? undefined : CarPaintProtectionTypeFromJSON(json['paintProtection']),
    };
}
export function CarServiceDtoToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'bodyType': CarBodyTypeToJSON(value.bodyType),
        'fuel': FuelTypeToJSON(value.fuel),
        'engineOil': value.engineOil,
        'drive': DriveTypeToJSON(value.drive),
        'gear': GearTypeToJSON(value.gear),
        'bodyColorId': value.bodyColorId,
        'bodyColorMakeCode': value.bodyColorMakeCode,
        'paintEffect': PaintEffectTypeToJSON(value.paintEffect),
        'paintProtection': CarPaintProtectionTypeToJSON(value.paintProtection),
    };
}
